import React, { useEffect, useState } from 'react'
import { Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap'
import Button from 'react-bootstrap/esm/Button'
import { envAwarePost } from '../../util/util';
import './Trainers.css';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import useAccountTypeName from '../../hooks/useAccountTypeName';
import useBranding from '../../hooks/useBranding'


const PasswordModal = ({ show, onHide, trainer }) => {
    const [status, setStatus] = useState('idle')
    const [password, setPassword] = useState('')
    const handleUpdatePassword = () => {
        if (password.length < 6) {
            alert('Password must be at least 6 characters long.')
            return
        }
        setStatus('pending')
        envAwarePost('api/users/api/', {
            trainer_id: trainer.user_id_number,
            action: 'editTrainerPassword',
            user_password: password,
        }).then(res => {
            setStatus('idle')
            const { success, message } = res
            if (success === '1') {
                onHide()
            } else {
                alert(message)
            }
        })
    }
    return (
        <Modal
            className="TrainerModal"
            onHide={onHide}
            show={show}
            size="sm"
            centered
        >
            <Modal.Header closeButton>
                {trainer?.user_name}
            </Modal.Header>
            <Modal.Body>
                <Form.Control
                    onChange={e => { setPassword(e.target.value) }}
                    placeholder="new password"
                    className="mb-2"
                    type="password"
                />
                <Button
                    onClick={handleUpdatePassword}
                    disabled={status === 'pending'}
                    variant="outline-primary"
                    block
                >
                    Update Password {status === 'pending' && <Spinner animation="border" size="sm" />}
                </Button>
            </Modal.Body>
        </Modal>
    )
}

function Trainers() {

    const [trainers, setTrainers] = useState([])
    const [addTrainersModal, setAddTrainersModal] = useState(false)
    const [editTrainersModal, setEditTrainersModal] = useState(false)
    const [trainerName, setTrainerName] = useState("")
    const [loginEmail, setLoginEmail] = useState("")
    const [contactEmail, setContactEmail] = useState("")
    const [trainerID, setTrainerID] = useState("")
    const [password, setPassword] = useState("")
    const [deleteId, setDeleteId] = useState("")
    const [deleteModal, setDeleteModal] = useState(false)
    const dispatch = useDispatch()
    const [loader, setLoader] = useState(false)
    const [showPasswordModal, setShowPasswordModal] = useState(false)
    const [trainerToEdit, setTrainerToEdit] = useState(null)
    const [loadingSpinner, setLoadingSpinner] = useState(false)
    const user = useSelector(state => state.users.current_user)
    const resolvedGymAccountName = useAccountTypeName('gym')
    const [userToDelete, setUserToDelete] = useState("")


    function getTrainers() {
        envAwarePost('api/users/api.php', {
            action: 'getAllTrainers',
        }).then((res) => {
            // console.log(res.data)
            setTrainers(res.data)
            setLoader(false)
            setLoadingSpinner(false)
        })
    }

    useEffect(() => {
        setLoadingSpinner(true)
        getTrainers();
    }, [])



    const addTrainer = () => {
        setLoader(true)
        envAwarePost('api/users/api/', {
            action: 'addTrainer',
            user_id: loginEmail,
            user_email: loginEmail,
            user_name: trainerName,
            user_password: password,
        }).then(res => {
            if (res.success === "1") {
                setAddTrainersModal(false)
                clearTrainersModal();
                getTrainers();
            } else {
                setLoader(false)
                alert(res.message);
            }
        }
        ).catch(err => {
            console.log("Error:-", err)
        })
    }

    const editTrainerInfo = (trainer) => {
        setTrainerName(trainer.user_name)
        setTrainerID(trainer.user_id_number)
        setLoginEmail(trainer.user_id)
        setContactEmail(trainer.user_email)
        setEditTrainersModal(true)
    }

    const clearTrainersModal = () => {
        setTrainerName("")
        setTrainerID("")
        setLoginEmail("")
        setPassword("")
        setContactEmail("")
    }

    const updateTrainerInfo = (e) => {
        e.preventDefault()
        setLoadingSpinner(true)
        envAwarePost('api/users/api/', {
            action: 'editTrainer',
            user_id: loginEmail,
            user_name: trainerName,
            user_email: contactEmail,
            trainer_id: trainerID,
            user_password: password,
        }).then(res => {
            if (res.success === "1") {
                setEditTrainersModal(false)
                clearTrainersModal();
                getTrainers();
            } else {
                setLoadingSpinner(false)
                alert(res.message);
            }
        }).catch(err => {
            console.log("Error:-", err)
            setEditTrainersModal(false)
        })
    }

    const openDeleteModal = (id, username) => {
        setDeleteModal(true)
        setUserToDelete(username)
        setDeleteId(id)
    }

    const deleteValue = (id) => {
        setDeleteModal(false)
        setLoadingSpinner(true)
        envAwarePost('api/users/api/', {
            action: 'deleteTrainer',
            trainer_id: deleteId,
        }).then(res => {
            getTrainers();
        }).catch(err => {
            console.log("Error:-", err)
        })
    }

    const handleChangeTrainerPassword = trainer => {
        setShowPasswordModal(true)
        setTrainerToEdit(trainer)
    }
    
	const customBranding = useBranding()

    return (
        <div className="pt-2 px-2 px-md-3">
            <div>
               
                <div className="trainer__addNewtrainer mt-2">
                    <div className="d-flex justify-content-between mb-2 w-100">
                        <strong>Trainers</strong>
                        <Button 
                            onClick={() => setAddTrainersModal(true)} 
                            variant="outline-success"
                            size="sm"
                        >
                            Add New Trainer
                        </Button>
                    </div>
                    <Modal
                        className="TrainerModal"
                        centered
                        size="lg"
                        show={addTrainersModal}
                    >
                        <Modal.Header closeButton onClick={() => setAddTrainersModal(false)} >
                            <Modal.Title id="contained-modal-title-vcenter">
                                Add New Trainer
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2}>
                                        Login Email
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control placeholder="Email" value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2}>
                                        Password
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2}>
                                        Display Name
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Display Name" onChange={(e) => setTrainerName(e.target.value)} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="danger" onClick={() => setAddTrainersModal(false)}>Cancel</Button>
                            <Button variant="success" onClick={() => { !loader && addTrainer() }}> {loader ? <Spinner size="sm" animation="border" style={{ textAlign: "center" }} /> : <span> Add </span>}</Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div className="trainers__list">
                    <Table striped hover size="sm">
                        <thead style={{ backgroundColor: '#4dd1ff', textAlign: "center" }}>
                            <tr>
                                <th>Trainer</th>
                                <th>Login <span className="d-none d-md-block">As This Trainer</span></th>
                                <th>Edit <span className="d-none d-md-block">Trainer Info</span></th>
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <>
                            {loadingSpinner ?
                                <div className="mt-2" style={{ textAlign: "center" }}>
                                    <Spinner animation="border" variant="primary" style={{ textAlign: "center" }} />
                                </div>
                                : null
                            }
                        </>
                        {loader ? <div style={{ display: "flex" }}>
                            <Spinner animation="border" variant="primary" style={{ textAlign: "center" }} />
                            <p className="loading-text">Please Wait, Trainer Account is being setup</p>
                        </div>
                            : null}
                        {trainers && trainers.map(trainer => (
                            <tbody key={trainer.user_id_number}>
                                <tr>
                                    <td>
                                        <div>{trainer.user_name}</div>
                                        <div>
                                            <small
                                                onClick={() => {
                                                    handleChangeTrainerPassword(trainer)
                                                }}
                                                className="mt-1 text-primary"
                                                style={{ cursor: 'pointer' }}
                                                tabIndex={0}
                                            >
                                                change password
                                            </small>
                                        </div>
                                    </td>
                                    <td className="trainer__login"><Button href={`/trainer/?trainer=`
                                        + trainer.user_id_number} size="sm">Login</Button></td>
                                    <td className="trainer__edit"><Button size="sm" style={{ border: ".1rem #17a2b8 solid" }} variant="info" onClick={(e) => { e.target.blur(); editTrainerInfo(trainer) }}>Edit</Button></td>
                                    <td className="trainer__delete" onClick={(e) => openDeleteModal(trainer.user_id_number, trainer.user_name)}><Button size="sm" variant="danger">Delete</Button></td>
                                </tr>
                            </tbody>
                        ))}
                    </Table>
                    <Modal
                        className="TrainerModal"
                        centered
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        show={editTrainersModal}
                    >
                        <Modal.Header closeButton onClick={() => { setEditTrainersModal(false); clearTrainersModal(); }} >
                            <Modal.Title id="contained-modal-title-vcenter">
                                Edit Info of Trainer
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2}>
                                        Login Email
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="email" value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2}>
                                        Display Name
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" value={trainerName} onChange={(e) => setTrainerName(e.target.value)} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2}>
                                        Contact Email
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="danger" onClick={() => { setEditTrainersModal(false); clearTrainersModal() }}>Cancel</Button>
                            <Button variant="success" onClick={(e) => { !loadingSpinner && updateTrainerInfo(e) }}> {loadingSpinner ? <Spinner size="sm" animation="border" style={{ textAlign: "center" }} /> : <span> Update </span>}</Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={deleteModal}
                    >
                        <Modal.Header closeButton onClick={() => setDeleteModal(false)}>
                            <Modal.Title id="contained-modal-title-vcenter">
                                Delete Trainer
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h4></h4>
                            <p>
                                Are you sure you want to delete <b> {userToDelete}</b>?
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                            <Button onClick={deleteValue} variant="danger">Delete</Button>
                        </Modal.Footer>
                    </Modal>
                    <PasswordModal
                        trainer={trainerToEdit}
                        show={showPasswordModal}
                        onHide={() => { setShowPasswordModal(false) }}
                    />
                </div>
            </div>
        </div >
    )
}

export default Trainers
